import {
  arrowUp,
  dashboardProfile,
  download,
  feesStats,
  messages,
  studentDashboard,
  teachersStats,
  upload,
} from "../asset";

export const whatsaapNumber = "+919113887558";
export const instaId = "https://www.instagram.com/empedance_official";
export const linkedInId =
  "https://www.linkedin.com/company/empedance-consultancy-services";

export const mailId = "help@empedance.com";
export const hrMailId = "hr@empedance.com";

//====================== Images ======================
export const mobileAndAndroid =
  "https://clapurban.blr1.digitaloceanspaces.com/1734159840440_mobile_app_development.svg";
export const websiteDevelopment =
  "https://clapurban.blr1.digitaloceanspaces.com/1734160798840_website_development.jpg";
export const uiUxDesign =
  "https://clapurban.blr1.digitaloceanspaces.com/1734160961875_ui_ux_design.jpg";
export const artificialInteligence =
  "https://clapurban.blr1.digitaloceanspaces.com/1734161133085_ai.jpg";

export const VideoEditing =
  "https://clapurban.blr1.digitaloceanspaces.com/1734161244228_video_editing.jpg";

export const ServiceLines =
  "https://clapurban.blr1.digitaloceanspaces.com/1734161403611_services_lines.svg";
export const whoAreWeBanner =
  "https://clapurban.blr1.digitaloceanspaces.com/1734166881804_about_emplux.jpg";

export const OfficeImage =
  "https://clapurban.blr1.digitaloceanspaces.com/1734167644166_empedance_office.jpg";
export const AboutUsLines =
  "https://clapurban.blr1.digitaloceanspaces.com/1734168291601_about_empedance_line.svg";
export const DefaultClient =
  "https://clapurban.blr1.digitaloceanspaces.com/1734181921061_default_client_image.png";

export const mobileServiceImages = [
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539798_mobile_app_development_sm.svg",
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539700_website_development_sm.svg",
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539749_ui_ux_design_sm.svg",
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539838_digital_marketing.svg",
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539921_artificial_inteligence_sm.svg",
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539877_video_editing_sm.svg",
];

export const altText = [
  "Professional web and mobile app development services tailored for businesses of all sizes.",
  "Custom website design and mobile app solutions to drive your digital growth.",
  "Expert web design and mobile app development for scalable digital solutions.",
  "Top web development and mobile app company delivering tailored digital experiences.",
  "Empowering businesses with custom website and mobile application development.",
  "Your trusted partner for innovative web design and mobile app solutions.",
  "Delivering high-performance websites and mobile apps for growing businesses.",
  "Customized web design, mobile app development, and digital marketing solutions.",
  "Leading digital agency specializing in web design, mobile development, and SEO services.",
  "Scalable, secure, and user-friendly web and mobile app development services.",
  "Transform your ideas into reality with our web and mobile app development expertise.",
  "Innovative web design and mobile app development solutions for every industry.",
  "Custom-built websites and mobile apps to meet unique business goals.",
  "Enhance your online presence with our professional web and app development services.",
  "Building engaging digital experiences with bespoke web and mobile applications.",
  "Your digital transformation partner for web design and mobile app innovation.",
  "Drive results with expert web design, mobile app development, and SEO strategies.",
  "Tailored web and mobile app solutions for businesses seeking digital excellence.",
  "Providing exceptional web and mobile development services to accelerate growth.",
  "Your go-to agency for creative web design, mobile apps, and digital marketing solutions.",
];

export const schoolCode = "OAVRS";
export const schoolName = "OSHO ANTARRASHTRIYA VIDYALAYA RESIDENTIAL SCHOOL ";
// export const branchCode = "BRC-1c3dd53b"

export const dashboardStats = [
  {
    title: "Students Present Today",
    icon: studentDashboard,
    value: 490,
    total: 540,
    type: "attendance",
  },
  {
    title: "Teacher’s Present Today",
    icon: teachersStats,
    value: 49,
    total: 54,
    type: "attendance",
  },
  {
    title: "Fee Collection Status",
    icon: feesStats,
    value: 362,
    total: 540,
    type: "fees",
    label: "Paid",
  },
];

export const eventsData = [
  // {
  //   date : "Wed 21 Jan, 2026",
  //   time : "10:00 AM",
  //   eventName : "Annual Sports Day"
  // },
  // {
  //   date : "Wed 21 Jan, 2026",
  //   time : "10:00 AM",
  //   eventName : "Annual Day"
  // }
];

export const manageQueriesData = [
  {
    profile: dashboardProfile,
    name: "Sakshi Singh",
  },
  {
    profile: dashboardProfile,
    name: "Sakshi Singh",
  },
  {
    profile: dashboardProfile,
    name: "Sakshi Singh",
  },
  {
    profile: dashboardProfile,
    name: "Sakshi Singh",
  },
  {
    profile: dashboardProfile,
    name: "Sakshi Singh",
  },
  {
    profile: dashboardProfile,
    name: "Sakshi Singh",
  },
];

export const LeaveRequestData = [
  // {
  //   type: "student",
  //   profile: dashboardProfile,
  //   name: "Sakshi Singh",
  //   messages: "Sir, I need a leave on Monday 12 January, 2026 as I have to go to my sister’s wedding, please grant me a leave of 1 day "
  // },
  // {
  //   type: "staff",
  //   profile: dashboardProfile,
  //   name: "Sakshi Singh",
  //   messages: "Sir, I need a leave on Monday 12 January, 2026 as I have to go to my sister’s wedding, please grant me a leave of 1 day "
  // },
  // {
  //   profile: dashboardProfile,
  //   name: "Sakshi Singh",
  //   messages: "Sir, I need a leave on Monday 12 January, 2026 as I have to go to my sister’s wedding, please grant me a leave of 1 day "
  // }
];

export const notificationData = [
  // {
  //   status: "read",
  //   profile: dashboardProfile,
  //   name: "Sakshi Singh",
  //   messages: "sent you a message",
  //   time: "now",
  //   type: "Messages",
  // },
  // {
  //   status: "unread",
  //   profile: dashboardProfile,
  //   messages:
  //     "21 students have marked the assignment Social Resp.... completed.",
  //   time: "01-01-2026",
  //   type: "assignment",
  // },
  // {
  //   status: "unread",
  //   profile: dashboardProfile,
  //   messages: "You have been assigned 3 new classes.",
  //   time: "yesterday",
  //   type: "assigned",
  // },
  // {
  //   status: "read",
  //   profile: dashboardProfile,
  //   name: "Sakshi Singh",
  //   messages: "sent you a message",
  //   time: "now",
  //   type: "Messages",
  // },
];

export const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const periods = [
  "Period 1",
  "Period 2",
  "Period 3",
  "Period 4",
  "Period 5",
  "Period 6",
  "Period 7",
];

export const colorMap = {
  red: "border-error-600 bg-error-50 text-error-600 hover:bg-error-100",
  green:
    "border-success-600 bg-success-50 text-success-700 hover:bg-success-100",
  blue: "border-primary-600 bg-primary-50 text-primary-600 hover:bg-primary-100",
  orange:
    "border-warning-600 bg-warning-50 text-warning-600 hover:bg-warning-100",
};

export const searchRouteMap: Record<string, string> = {
  dashboard: "/",
  staff: "/staff",
  students: "/all-students",
  classes: "/classes",
  groups: "/groups-houses",
  admissions: "/admissions",
  queries: "/queries",
  messages: "/messages",
  notice: "/notice-board",
  academic: "/academic-preferences",
  exams: "/exams-and-assignments",
  assignments: "/exams-and-assignments",
  forms: "/forms",
  fees: "/fees-and-payments",
  payroll: "/payroll-management",
  calendar: "/calendar-and-events",
  timetable: "/timetable",
  help: "/help",
  media: "/media-gallery",
};

export const MONTHS = [
  "JANUARY",
  "FEBRUARY",
  "MARCH",
  "APRIL",
  "MAY",
  "JUNE",
  "JULY",
  "AUGUST",
  "SEPTEMBER",
  "OCTOBER",
  "NOVEMBER",
  "DECEMBER",
];

export const STATUS_DISPLAY_MAP: Record<string, string> = {
  PRESENT: "P",
  ABSENT: "Ab",
  HALF_DAY: "HD",
  HOLIDAY: "H",
  WEEKEND: "W",
};

export const getStatusStyles = (status: string | null) => {
  switch (status) {
    case "PRESENT":
      return "text-success-600 bg-white border-b-green-600";
    case "ABSENT":
      return "text-error-500 bg-white border-b-red-500";
    case "WEEKEND":
      return "text-warning-200 bg-warning-50";
    case "HOLIDAY":
      return "text-primary-500 bg-primary-50 border-b-primary-600";
    case "HALF_DAY":
      return "text-netural-500 bg-netural-50 border-b-netural-600";
    default:
      return "bg-white text-neutral-300";
  }
};
